export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher..."])},
        "organizations_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organisations"])},
        "stores_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins"])}
      },
      "en": {
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search..."])},
        "organizations_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organizations"])},
        "stores_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stores"])}
      }
    }
  })
}
